import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {TdoTableActionsEnum, TdoTableModel} from './models/tdo-table.model';
import {TdoTableEvent} from './models/tdo-table.event';
import {TdoSearchEvent} from '../tdo-search/models/TdoSearchEvent';
import {ITdoTableItemModel} from './interfaces/i-tdo-table-item.model';
import {MatPaginator} from '@angular/material/paginator';
import {TdoTableBaseItemModel} from './models/tdo-table-base-item.model';

@Component({
  selector: 'app-tdo-table',
  templateUrl: './tdo-table.component.html',
  styleUrls: ['./tdo-table.component.scss']
})
export class TdoTableComponent implements OnInit, AfterViewInit {
  @Input() displayedColumns: string[];
  @Input() dataSource: MatTableDataSource<ITdoTableItemModel>;
  @Input() tdoTableModel: TdoTableModel;
  @Input() isSearchable = true;
  @Input() actionStyle = '';
  @Input() sortActive = null;
  @Input() sortDirection = null;
  @Input() noDataMessage = 'No data to display';
  /*@Input() set selectedItem(value: TdoTableBaseItemModel) {
    if (!value) {
      return;
    }
    if (this.selection){
      this.selection.select(value);
      this.itemSelected.emit(new TdoTableEvent(value));
    }
  }*/
  // Multi-select
  @Input() isMultiSelect = false;
  @Input() isUsePaginator = false;
  @Input() pageSize: number = 30;
  @Input() pageSizeOptions: number[];

  // TODO: Coming soon
  // @Input() customDataSource: DataSource<any>;

  @Output() actionClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() editComplete: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  selection = new SelectionModel<any>();
  searchInputValue = '';

  private lastSelectedRow: ITdoTableItemModel;

  constructor() {

  }

  getLabelByKey(key: string): string {
    return this.tdoTableModel.getLabelByKey(key);
  }

  getIsColumnEditable(item: ITdoTableItemModel, key: string): boolean {
    if (!this.tdoTableModel.editableColumns) {
      return item.isEditMode;
    } else {
      if (this.tdoTableModel.editableColumns.includes(key) && item.isEditMode) {
        // if editableRowColumns was set
        if (item.editableRowColumns) {
          if (item.editableRowColumns.includes(key)) {
            return true;
          }
        }
        else {
          // editableRowColumns was not set
          return true;
        }
      }
    }

    return false;
  }

  getActionRowStyle(item: ITdoTableItemModel): string {
    if (!this.dataSource || this.dataSource.data.length === 0) {
      return '';
    }

    if (!item.actions) {
      return '';
    }

    const numActions = item.actions.length;
    return `width: ${numActions * 40}px; cursor: pointer;`;
  }

  ngOnInit(): void {
    if (this.isMultiSelect) {
      this.selection = new SelectionModel<any>(this.isMultiSelect, []);
    }
    this.displayedColumns = this.tdoTableModel.displayedColumns;
    if (this.tdoTableModel.dataSource instanceof MatTableDataSource) {
      this.dataSource = this.tdoTableModel.dataSource as MatTableDataSource<any>;
      this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
        if (typeof data[sortHeaderId] === 'string') {
          return data[sortHeaderId].toLocaleLowerCase();
        }

        return data[sortHeaderId];
      };
      if (!this.sortActive) {
        if (this.tdoTableModel.sortActive) {
          this.sortActive = this.tdoTableModel.sortActive;
        }
      }

      if (!this.sortDirection) {
        if (this.tdoTableModel.sortDirection) {
          this.sortDirection = this.tdoTableModel.sortDirection;
        } else {
          this.sortDirection = 'asc';
        }
      }
    } else {
      // TODO: implement custom DataSource
    }

    const selectedData = (this.tdoTableModel.dataSource as MatTableDataSource<TdoTableBaseItemModel>).data.find(p => p.isSelected === true);
    if (selectedData) {
      this.selection.select(selectedData);
    }
  }

  applySearchFilter(event: TdoSearchEvent): void {
    this.searchInputValue = event.value;
    this.dataSource.filterPredicate = this.tdoTableModel.searchPredicate;
    this.dataSource.filter = this.searchInputValue.toLowerCase();

    if (this.dataSource.paginator && this.isUsePaginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onEditComplete(event, row) {
    this.editComplete.emit(new TdoTableEvent(row, TdoTableActionsEnum.EDIT));
  }

  onRowSelected(event, row): void {
    // Edit mode not usable with multi row select mode
    if (!this.isMultiSelect) {
      if (this.lastSelectedRow && this.lastSelectedRow !== row && this.lastSelectedRow.isEditMode) {
        this.lastSelectedRow.isEditMode = false;
        this.onEditComplete(event, this.lastSelectedRow);
      }
    }

    this.lastSelectedRow = row;
    if (this.selection.isSelected(row)) {
      if (this.isMultiSelect) {
        this.selection.deselect(row);
      }
    } else {
      this.selection.select(row);
      this.itemSelected.emit(new TdoTableEvent(row));
    }
  }

  onRowActionClick(event, row, action): void {
    this.actionClick.emit(new TdoTableEvent(row, action));
    switch (action) {
      case TdoTableActionsEnum.EDIT:
        row.isEditMode = true;
        break;
    }
  }

  ngAfterViewInit(): void {
    if (this.dataSource.data.length > 0) {
      this.sort.active = this.sortActive;
      this.sort.direction = this.sortDirection;
      this.dataSource.sort = this.sort;
      if (this.paginator && this.isUsePaginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
  }

  selectRow(model: any) {
    if (model) {
      const smodel = this.dataSource.data.find(p => (p as any).model === model);
      if (smodel) {
        this.selection.select(smodel);
      }
    }
  }
}
